import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import {
  ApiPhoneSigninResponse,
  ApiTenantAuthRequest,
  ApiTenantOtpVerifyRequest,
  ApiTokenResponse,
} from '~shared/types';

export const tenantSendOtp = async (sendOtpData: ApiTenantAuthRequest) => {
  const { data }: AxiosResponse<ApiPhoneSigninResponse> =
    await HttpService.post('/tenant/auth/send-otp', sendOtpData, {
      _skipAuthRefresh: true,
    });

  return data;
};

export const tenantVerifyOtp = async (
  verifyOtpData: ApiTenantOtpVerifyRequest,
) => {
  const { data }: AxiosResponse<ApiTokenResponse> = await HttpService.post(
    '/tenant/auth/verify-otp',
    verifyOtpData,
    { _skipAuthRefresh: true },
  );

  return data;
};
